<template>
	<div id="purchases">
		<!-- add/edit dialog -->
		<v-dialog v-model="dialog" attach persistent :max-width="isBlackPepper ? 800 : 500" >
			<v-form ref="purchaseForm" @submit.prevent="submit" :disabled="submitLoading || isPreview">
				<v-card>
					<v-card-title class="justify-center text-capitalize primary--text">
						<v-btn @click="dialog = false" icon>
							<v-icon>$close</v-icon>
						</v-btn>
						<v-spacer/>
						<span class="me-8">
							{{
								!isPreview
									? !purchaseItem.id ? $T('add-purchase') : $T('edit-purchase')
									: $T('preview-purchase')
							}}
						</span>
						<v-spacer/>
					</v-card-title>
					<v-card-text class="pb-0">
						<v-row>
							<v-col :cols="isBlackPepper ? 6 : 12" class="py-0">
								<v-row dense class="outline-container ma-0 mb-2">
									<!-- type -->
									<v-col v-if="!isBlackPepper" sm="6" cols="12">
										<v-autocomplete
											v-model.number="dialogData.isSeed"
											:label="$T('inputs.type')"
											:items="[
												{ id: 1, name: 'Cardamom', value: false },
												{ id: 2, name: 'Seeds', value: true }
											]"
											item-text="name"
											item-value="value"
											hide-spin-buttons
											dense
											outlined
											hide-details
											:rules="rules.requiredAsNumber"
										></v-autocomplete>
									</v-col>
									
									<!-- date -->
									<v-col sm="6" cols="12">
										<bee-date-picker
											v-model="dialogData.date"
											:label="$T('inputs.date')"
											dense
											outlined
											hide-details
											menu-picker
											:input-props="{ readonly: true, dense: true, outlined: true }"
											:rules="rules.required"
										></bee-date-picker>
									</v-col>

									<!-- provider -->
									<v-col sm="6" cols="12">
										<v-autocomplete
											v-model="dialogData.providerId"
											:items="providers"
											item-text="name"
											item-value="id"
											:label="$T('inputs.provider')"
											dense
											outlined
											hide-details
											:rules="rules.required"
											@change="getWeightedAveragesByProvider(dialogData.providerId)"
										></v-autocomplete>
									</v-col>
									
									<!-- no -->
									<v-col sm="6" cols="12">
										<v-text-field
											v-model="dialogData.entryNo"
											:label="$T('inputs.entry-no')"
											dense
											outlined
											hide-details
										></v-text-field>
									</v-col>
									
									<!-- density -->
									<v-col sm="6" cols="12">
										<v-text-field
											v-model.number="dialogData.density"
											:label="$T('inputs.density')"
											type="number"
											min="0"
											hide-spin-buttons
											dense
											outlined
											hide-details
											:rules="rules.requiredAsNumber"
										></v-text-field>
									</v-col>
									<template v-if="isBlackPepper">
										<v-col cols="12" sm="6">
											<v-text-field
												v-model="dialogData.grande"
												:label="$T('inputs.large') + ' (%)'"
												type="number"
												min="0"
												hide-spin-buttons
												dense
												outlined
												hide-details
											/>
										</v-col>

										<v-col cols="12" sm="6">
											<v-text-field
												v-model="dialogData.mediano"
												:label="$T('inputs.medium') + ' (%)'"
												type="number"
												min="0"
												hide-spin-buttons
												dense
												outlined
												hide-details
											/>
										</v-col>

										<v-col cols="12" sm="6">
											<v-text-field
												v-model="dialogData.pequeño"
												:label="$T('inputs.little') + ' (%)'"
												type="number"
												min="0"
												hide-spin-buttons
												dense
												outlined
												hide-details
											/>
										</v-col>
										<v-col cols="12" sm="6">
											<v-text-field
												v-model="dialogData.con_Collila"
												:label="$T('inputs.con-collila') + ' (%)'"
												type="number"
												min="0"
												hide-spin-buttons
												dense
												outlined
												hide-details
											/>
										</v-col>
										<v-col cols="12" sm="6">
											<v-text-field
												v-model="dialogData.maduro"
												:label="$T('inputs.mature') + ' (%)'"
												type="number"
												min="0"
												hide-spin-buttons
												dense
												outlined
												hide-details
											/>
										</v-col>
										<v-col cols="12" sm="6">
											<v-text-field
												v-model="dialogData.quebrado"
												:label="$T('inputs.broken') + ' (%)'"
												type="number"
												min="0"
												hide-spin-buttons
												dense
												outlined
												hide-details
											/>
										</v-col>
										<v-col cols="12" sm="6">
											<v-text-field
												v-model="dialogData.mohoso"
												:label="$T('inputs.moldy') + ' (%)'"
												type="number"
												min="0"
												hide-spin-buttons
												dense
												outlined
												hide-details
											/>
										</v-col>
										<v-col cols="12" sm="6">
											<v-text-field
												v-model="dialogData.hojos"
												:label="$T('inputs.leaves') + ' (%)'"
												type="number"
												min="0"
												hide-spin-buttons
												dense
												outlined
												hide-details
											/>
										</v-col>
										<v-col cols="12" sm="6">
											<v-text-field
												v-model="dialogData.colpila"
												:label="$T('inputs.colpila') + ' (%)'"
												type="number"
												min="0"
												hide-spin-buttons
												dense
												outlined
												hide-details
											/>
										</v-col>

										<v-col cols="12" sm="6">
											<v-text-field
												v-model="dialogData.verde"
												:label="$T('inputs.verde') + ' (%)'"
												type="number"
												min="0"
												hide-spin-buttons
												dense
												outlined
												hide-details
											/>
										</v-col>
									</template>
								</v-row>

								<!-- purchase Item sub-tree -->
								<v-row v-if="0" dense class="mb-0">
									<v-col md="6" sm="8" cols="12">
										<v-autocomplete
											v-model="purchaseSubTreeItemId"
											:label="$T('inputs.item-to-purchase-from')"
											:items="itemsTree"
											item-text="name"
											item-value="id"
											hide-details
											dense
											outlined
											readonly
											@change="updatePurchaseEntires"
										></v-autocomplete>
									</v-col>
								</v-row>
							</v-col>

							<v-col :cols="isBlackPepper ? 6 : 12" class="py-0">
								<!-- table -->
								<template v-if="!dialogData.isSeed">
									<bee-handy-smart-table
										v-model="tableInputs"
										ref="entiresTable"
										:headers="dialogHeaders"
										:items="!loadingWeightedAverages ? dialogData.entires : []"
										:items-per-page="-1"
										fixed-header
										:height="$vuetify.breakpoint.height - 390"
										zebra
										dense
										hot-inputs
										hide-default-footer
										hide-inputs-details
										:show-add-row="showAddRow"
										:data-table-props="{
											disableSort: true,
											noDataText: $T('messages.select-Item-to-purchase')
										}"
										:loading="loadingWeightedAverages"
									>
										<!-- @keypress.enter="
											dialogData.entires.push({ ...tableInputs });
											$refs.table.resetInputs();
											showAddRow = false;
										" -->
										<!-- item name -->
										<template v-slot:item.itemName="{ item }">
											{{item.itemName}}
											<span v-if="item.parentName" class="ms-1 text-caption grey--text">
												({{item.parentName}})
											</span>
										</template>

										<!-- actions -->
										<template v-slot:item.actions="{ item, index }">
											<v-btn
												v-if="item.isNotDefault"
												icon
												@click="dialogData.entires.splice(index, 1)"
												color="alert-color"
											>
												<v-icon>$delete</v-icon>
											</v-btn>
										</template>

										<!-- foot -->
										<template v-if="0" v-slot:foot>
											<tr>
												<td class="custom-foot-row px-2"></td>
												<td class="custom-foot-row px-2"></td>
												<td class="custom-foot-row px-2 text-end">
													<v-btn
														text
														class="px-1"
														color="grey darken-4"
														@click="showAddRow = !showAddRow"
													>
														<v-icon class="me-2">$add</v-icon>
														<span v-if="!showAddRow">{{$T('add')}} {{$T('headers.item')}}</span>
														<span v-else>{{$T('close')}}</span>
													</v-btn>
												</td>
											</tr>
										</template>
									</bee-handy-smart-table>

									<v-divider class="mt-3 mb-2"/>
									<div class="d-flex text-body-1 font-weight-bold primary--text">
										<div class="px-2" style="width: 120px">
											Total
										</div>
										<v-spacer/>
										<div
											:class="{'red--text': totalPercent !== 100}"
											class="ps-2"
											style="width: 30%"
										>
											{{totalPercent}}%
											<v-icon v-if="totalPercent !== 100" color="red">$alert</v-icon>
										</div>
									</div>
								</template>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions class="justify-end">
						<v-btn
							v-if="!isPreview"
							type="submit"
							color="primary"
							:loading="submitLoading"
						>{{$T('save')}}</v-btn>
						<v-btn @click="dialog = false" :disabled="submitLoading">{{$T('close')}}</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<!-- status dialog -->
		<v-dialog v-model="statusDialog" max-width="400">
			<v-form
				ref="statusForm"
				@submit.prevent="submitAcceptance"
				:disabled="submitLoading"
			>
				<v-card>
					<v-card-title class="justify-center text-capitalize primary--text">
						<v-btn @click="statusDialog = false" icon>
							<v-icon>$close</v-icon>
						</v-btn>
						<v-spacer/>
						<span class="me-8">
							{{$T('purchase-status')}}
						</span>
						<v-spacer/>
					</v-card-title>
					<v-card-text class="pb-2">
						<v-row align="center" dense>
							<!-- administration price  -->
							<v-col sm="8" cols="12" class="text-body-1 grey--text text--darken-2">
								{{$T('administration-price')}}
							</v-col>
							<v-col sm="4" cols="12">
								<v-text-field
									v-model="itemState.priceFormat"
									v-number-format.number="[itemState.priceFormat, itemState.price]"
									:label="$T('inputs.price')"
									dense
									outlined
									hide-details
									:rules="rules.required"
									:disabled="(isPreview && !isAdmin)"
								/>
							</v-col>

							<!-- administration-acceptance -->
							<v-col sm="8" cols="12" class="text-body-1 grey--text text--darken-2">
								{{$T('administration-acceptance')}}
							</v-col>
							<v-col sm="4" cols="12">
								<v-checkbox
									v-model="itemState.administrationAcceptance"
									:indeterminate="itemState.administrationAcceptance === null"
									:success="itemState.administrationAcceptance"
									:error="itemState.administrationAcceptance === false"
									off-icon="mdi-close-box"
									hide-details
									:ripple="false"
									class="ma-0"
									:disabled="isPreview"
								>
									<!-- :readonly="itemState.status !== purchaseStatus.pending" -->
									<template v-slot:label>
										<span :class="getStatusColor(itemState.administrationAcceptance)">
											{{getStatusText(itemState.administrationAcceptance)}}
										</span>
									</template>
								</v-checkbox>
							</v-col>
				
							<!-- farmer-acceptance -->
							<v-col sm="8" cols="12" class="text-body-1 grey--text text--darken-2">
								{{$T('farmer-acceptance')}}
							</v-col>
							<v-col sm="4" cols="12">
								<v-checkbox
									v-model="itemState.farmerAcceptance"
									:indeterminate="itemState.farmerAcceptance === null"
									:success="itemState.farmerAcceptance"
									:error="itemState.farmerAcceptance === false"
									off-icon="mdi-close-box"
									hide-details
									:ripple="false"
									class="ma-0"
									:disabled="isPreview"
								>
									<!-- :readonly="itemState.status !== purchaseStatus.pending" -->
									<template v-slot:label>
										<span :class="getStatusColor(itemState.farmerAcceptance)">
											{{getStatusText(itemState.farmerAcceptance)}}
										</span>
									</template>
								</v-checkbox>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-spacer/>
						<template v-if="(!isPreview && itemState.status !== purchaseStatus.accepted) || isAdmin">
							<v-btn type="submit"  color="primary" :loading="submitLoading">
								{{$T('save')}}
							</v-btn>
							<v-btn @click="statusDialog = false" :disabled="submitLoading">
								{{$T('close')}}
							</v-btn>
						</template>

						<v-btn v-else color="primary" @click="statusDialog = false">
							{{$T('ok')}}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<!-- delete dialog -->
		<v-delete-dialog
			v-model="deleteDialog"
			module-type="purchases"
			:ids="purchaseItem.id"
			@on-delete="filter();"
			@input="!$event ? purchaseItem = {} : null"
		>
			{{$T('are-you-sure-you-want-to-$', { message: '' })}}
			<span class="text-uppercase alert-color--text">{{$T('delete')}}</span>
			{{$T('the-entry')}} <br>
			{{
				purchaseItem.administrationAcceptance && purchaseItem.farmerAcceptance
				? $T('alert-message') : ''
			}}
		</v-delete-dialog>

		<!-- filter -->
		<v-form @submit.prevent="filter()">
			<v-row dense align="center" class="mb-0">
				<!-- provider -->
				<v-col lg="2" md="3" sm="4" cols="12">
					<v-autocomplete
						v-model="filterData.providerId"
						:items="providers"
						item-text="name"
						item-value="id"
						:label="$T('inputs.provider')"
						outlined
						dense
						hide-details
					></v-autocomplete>
				</v-col>

				<!-- date -->
				<v-col lg="2" sm="auto" cols="12">
					<bee-date-picker
						v-model="filterData.date"
						:input-label="$T('inputs.date')"
						:input-props="{ dense: true, outlined: true, readonly: true, clearable: true, prependInnerIcon: '$calendar' }"
						menu-picker
						hide-details
					></bee-date-picker>
				</v-col>
				
				<!-- status -->
				<v-col lg="auto" md="4" sm="6" cols="12">
					<v-radio-group v-model="filterData.status" row dense hide-details class="ma-0">
						<span class="me-2">{{$T('status')}}</span>
						<v-radio :ripple="false" :label="$T('all')" :value="null"/>
						<v-radio :ripple="false" :label="$T('accepted')" :value="purchaseStatus.accepted"/>
						<v-radio :ripple="false" :label="$T('pending')" :value="purchaseStatus.pending"/>
						<v-radio :ripple="false" :label="$T('rejected')" :value="purchaseStatus.rejected"/>
					</v-radio-group>
				</v-col>

				<v-col cols="auto">
					<v-btn small type="submit" color="primary">
						<v-icon>$search</v-icon>
						<!-- {{$T('search')}} -->
					</v-btn>
				</v-col>

				<v-spacer/>

				<v-btn
					v-if="permissions.purchases.isReadWrite"
					small
					color="primary"
					@click="dialog = true"
				>
					<v-icon class="me-1">$add</v-icon>
					{{$T('add-purchase')}}
				</v-btn>
			</v-row>
		</v-form>

		<!-- table -->
		<bee-handy-table
			ref="table"
			:headers="headers"
			:items="[]"
			:items-per-page="20"
			fixed-header
			:height="$vuetify.breakpoint.height - 130"
			zebra
			dense
			pagination-on-scroll
			pagination-on-scroll-server-items
			:server-items-length="totalItems"
			:options-scroll.sync="scrollOptions"
			shown-rows-text
			:loading="loading"
			:data-table-props="{ disableSort: true }"
			@pagination-on-scroll:reach-last-row="filter"
		>
			<!-- administration acceptance -->
			<template v-slot:item.administrationAcceptance="{ item }">
				<v-icon
					v-if="item.administrationAcceptance !== null"
					:color="getStatusColor(item.administrationAcceptance, false)"
				>
					mdi-{{item.administrationAcceptance ? 'check-circle-outline' : 'close-circle-outline' }}
				</v-icon>
				<v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
			</template>

			<!-- farmer acceptance -->
			<template v-slot:item.farmerAcceptance="{ item }">
				<v-icon
					v-if="item.farmerAcceptance !== null"
					:color="getStatusColor(item.farmerAcceptance, false)"
				>
					mdi-{{item.farmerAcceptance ? 'check-circle-outline' : 'close-circle-outline' }}
				</v-icon>
				<v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
			</template>

			<!-- actions -->
			<template v-slot:item.actions="{ item }">
				<div class="d-flex flex-md-nowrap flex-wrap justify-space-between align-center">
					<v-tooltip top>
						<template v-slot:activator="{ attr, on }">
							<v-btn
								v-if="!permissions.purchasesSimulation.isNone"
								v-bind="attr"
								v-on="on"
								width="34"
								height="34"
								icon
								color="preview-color"
								class="me-1"
								:to="{ name: 'purchase-simulation', params: { id: item.id } }"
							>
								<v-icon>mdi-network-pos</v-icon>
							</v-btn>
						</template>
						{{$T('tooltips.purchase-simulation')}}
					</v-tooltip>

					<v-chip
						small
						dark
						:color="['success', 'warning', 'alert-color'][item.status - 1]"
						class="text-uppercase"
						@click="
							(item.administrationAcceptance && item.farmerAcceptance) ||
							permissions.purchases.isReadonly
								? isPreview = true
								: null;
							(() => { purchaseItem = item; setItemsStates(item); statusDialog = true })()
						"
					>
						{{$T(['accepted', 'pending', 'rejected'][item.status - 1])}}
					</v-chip>

					<v-tooltip top>
						<template v-slot:activator="{ attr, on }">
							<v-btn
								width="34"
								height="34"
								icon
								class="ms-1"
								color="#013859"
								:to="{
									name: 'compare',
									params: {
										id: item.id
									},
									query: {
										type: 'offer'
									}
								}"
								v-bind="attr"
								v-on="on"
							>
								<v-icon>$compare</v-icon>
							</v-btn>
						</template>
						{{ $T('compare') }}
					</v-tooltip>
					<v-btn
						v-if="item.administrationAcceptance && item.farmerAcceptance"
						width="34"
						height="34"
						icon
						color="preview-color"
						class="ms-1"
						@click="isPreview = true; purchaseItem = item; dialog = true;"
					>
						<v-icon>$view</v-icon>
					</v-btn>

					<v-btn
						v-else-if="permissions.purchases.isReadWrite"
						width="34"
						height="34"
						icon
						color="warning-color"
						class="ms-1"
						@click="purchaseItem = item; dialog = true;"
					>
						<v-icon>$edit</v-icon>
					</v-btn>
					<v-spacer v-else/>

					<v-btn
						v-if="permissions.purchases.isReadWrite"
						width="34"
						height="34"
						icon
						color="alert-color"
						class="ms-1"
						@click="purchaseItem = item; deleteDialog = true;"
					>
						<v-icon>$delete</v-icon>
					</v-btn>
				</div>
			</template>
		</bee-handy-table>
	</div>
</template>

<script>
import moment from 'moment'
import rules from '@/helpers/validation-rules'
import { fixNumber } from '@/helpers/functions'
import { mapGetters, mapState } from 'vuex'
import { purchaseStatus, itemCategory } from '@/helpers/enums'
import { isBlackPepper } from '@/global.config.js'

export default {
	name: 'Purchases',

	data() {
		return {
			// helpers
			loading: false,
			submitLoading: false,
			showAddRow: false,
			isPreview: false,
			
			dialog: false,
			purchaseItem: {},

			deleteDialog: false,

			statusDialog: null,
			itemState: {
				status: null,
				administrationAcceptance: null,
				farmerAcceptance: null,
				price: null,
				priceFormat: null
			},

			purchaseStatus,
			rules,

			// filter
			filterData: {
				providerId: null,
				date: null,
				status: null,
			},

			// pagination
			scrollOptions: {},
			totalItems: 0,
			
			// data
			tableInputs: {},
			purchaseSubTreeItemId: null,
			dialogData: {
				date: moment().format('YYYY-MM-DD'),
				providerId: null,
				entryNo: null,
				density: null,
				isSeed: false,

				entires: [],
				itemCategory,
				hojos: 0,
				colpila: 0,
				grande: 0,
				maduro: 0,
				mohoso: 0,
				quebrado: 0,
				pequeño: 0,
				mediano: 0,
				con_Collila: 0,
				verde: 0
			},
			isBlackPepper,
			loadingWeightedAverages: false
		}
	},

	watch: {
		dialog(val) {
			if (val) {
				this.dialogData.isSeed = false;
				this.purchaseSubTreeItemId = this.cardamomRootId || this.items[0]?.id;
				this.updatePurchaseEntires();

				this.dialogData.date = moment().format('YYYY-MM-DD');
				if (this.purchaseItem.id) {
					this.dialogData.date = moment(this.purchaseItem.date).format('YYYY-MM-DD')
					this.dialogData.providerId = this.purchaseItem.providerId;
					this.dialogData.entryNo = this.purchaseItem.entryNo;
					this.dialogData.density = this.purchaseItem.density;
					this.dialogData.isSeed = this.purchaseItem.isSeed;
					const removeIndexes = [];

					this.getWeightedAveragesByProvider(this.purchaseItem.providerId).finally(() => {
						this.dialogData.entires.forEach((entry, index) => {
							const item = this.purchaseItem.items.find(c => c.itemId === entry.id);
							if (item) {
								this.dialogData.entires[index].percent = item.percent;
							} else if (this.isPreview) {
								removeIndexes.push(index);
							}
						})
					})
					// })

					removeIndexes.forEach(index => { this.dialogData.entires[index] = {} });
					this.dialogData.entires = this.dialogData.entires.filter(c => Object.keys(c).length);

					this.dialogData.hojos = this.purchaseItem.hojos || null;
					this.dialogData.colpila = this.purchaseItem.colpila || null;
					this.dialogData.grande = this.purchaseItem.grande || null;
					this.dialogData.maduro = this.purchaseItem.maduro || null;
					this.dialogData.mohoso = this.purchaseItem.mohoso || null;
					this.dialogData.quebrado = this.purchaseItem.quebrado || null;
					this.dialogData.pequeño = this.purchaseItem.pequeño || null;
					this.dialogData.mediano = this.purchaseItem.mediano || null;
					this.dialogData.con_Collila = this.purchaseItem.con_Collila || null;
					this.dialogData.verde = this.purchaseItem.verde || null
				}
			} else {
				this.$refs.purchaseForm.reset();
				
				this.showAddRow = false;
				this.isPreview = false;
				this.purchaseItem = {};
				this.purchaseSubTreeItemId = null;

				this.dialogData.entires = [];
			}
		},
	
		statusDialog(val) {
			if (!val) {
				this.$refs.statusForm.reset();
				this.itemState.status = null;
				this.isPreview = false;
			}
		},
	},

	computed: {
		...mapState({
			permissions: state => state.auth.self.permissions,
			providers: state => state.configs.configsTrees.providers,
			cardamomRootId: state => state.configs.itemsConfigs.cardamomRootId,
			accountsTree: state => state.accounts.accountsTree,
			items: state => state.items.items,
			itemsTree: state => state.items.itemsTree,
			seedsId: state => state.configs.itemsConfigs.seedsId,
			isAdmin: state => state.auth.self.isAdmin
		}),

		...mapGetters({
			getAccountById: 'accounts/getAccountById'
		}),

		headers() {
			const headers = [
				{
					text: this.$T('headers.entry-no'),
					name: 'entryNo',
					value: 'entryNo',
					width: 100
				},
				{
					text: this.$T('headers.date'),
					name: 'date',
					value: 'date',
					type: 'date',
					dateFormat: 'YYYY-MM-DD',
					width: 120
				},
				{
					text: this.$T('headers.provider'),
					name: 'providerId',
					value: 'providerId',
					noNotAvailableText: true,
					setValueExpr: val => val ? this.getAccountById(val)?.name : 'Ugarit'
				},
				{
					text: this.$T('headers.weight'),
					name: 'weight',
					value: 'weight',
					type: 'number-format'
				},
				/*
				{
					text: this.$T('headers.px-cal'),
					name: 'pxCal',
					value: 'pxCal',
					type: 'number-format'
				}, */
				{
					text: this.$T('headers.density'),
					name: 'density',
					value: 'density',
					type: 'number-format'
				},
				/* {
					text: this.$T('headers.owner'),
					name: 'ownerId',
					value: 'ownerId',
					noNotAvailableText: true,
				}, */
				{
					text: this.$T('administration-acceptance'),
					name: 'administrationAcceptance',
					value: 'administrationAcceptance',
					align: 'center',
					sortable: false,
					width: 120,
				},
				{
					text: this.$T('farmer-acceptance'),
					name: 'farmerAcceptance',
					value: 'farmerAcceptance',
					align: 'center',
					sortable: false,
					width: 120,
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					columnClass: 'px-0',
					sortable: false,
					width: 100
				},
			];

			for (let i = 0; i < headers.length; i++) {
				headers[i].columnClass = headers[i].columnClass ? headers[i].columnClass + ' px-2' : 'px-2'
			}

			return headers;
		},

		// dialog
		dialogHeaders() {
			return [
				{
					text: this.$T('headers.item'),
					name: 'itemName',
					value: 'itemName',
					columnClass: 'px-2',
				},
				{
					text: this.$t('headers.average-percentages-of-previous-purchases') + ' %',
					name: 'weightedAveragePercentage',
					value: 'weightedAveragePercentage',
					setValueExpr: val => this.fixNumber(val),
					noNotAvailableText: true,
					cellClass: 'grey--text text-center',
					align: 'center'
				},
				{
					text: '%',
					name: 'percent',
					value: 'percent',
					class: 'text-h6',
					columnClass: 'px-2',
					type: 'number',
					inputRules: rules.requiredAsPercent,
					width: '30%',
					writable: true
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					width: 0,
					columnClass: 'px-0',
					noNotAvailableText: true,
					sortable: false,
					noInput: true,
				},
			]
		},

		totalPercent() {
			return this.dialogData.entires.map(c => c.percent).reduce((a, b) => +a + b, 0)
		},
	},

	methods: {
		updatePurchaseEntires() {
			this.dialogData.entires = [];
			if (!this.purchaseSubTreeItemId) return;
			const subTree = this.itemsTree.find(c => c.id === this.purchaseSubTreeItemId);

			subTree.children.filter(c => c.itemCategory === itemCategory.commercial).forEach(c => {
				this.dialogData.entires.push({
					id: c.id,
					itemName: c.name,
					parentName: null,
					percent: 0,
					weightedAveragePercentage: 0
				})
				/* if (!c.children.length) return;
				c.children.forEach(e => {
					this.dialogData.entires.push({
						id: e.id,
						itemName: e.name,
						parentName: c.name,
						percent: 0,
					})
				}) */
			})
		},

		filter(newScrollOptions) {
			let page = 1;
			if (newScrollOptions) {
				page = newScrollOptions.page
			} else if (this.$refs.table) {
				this.$refs.table.resetShownRows()
			}
			const itemsPerPage = this.scrollOptions.itemsPerPage;
			
			this.loading = true;
			return this.$store.dispatch('purchases/fetchAll', {
				providerId: this.filterData.providerId,
				date: this.filterData.date,
				status: this.filterData.status,
				page: page,
				perPage: itemsPerPage || 20,
			}).then(({ data, total }) => {
				this.totalItems = total;
				this.$refs.table.addScrollItems(data);
			}).finally(() => {
				this.loading = false;
			})
		},

		submit() {
			if (
				this.$refs.purchaseForm.validate() &&
				(this.totalPercent === 100 || this.dialogData.isSeed)
			) {
				this.submitLoading = true;
				const actionName = !this.purchaseItem.id ? 'create' : 'update';
				this.$store.dispatch(`purchases/${actionName}`, {
					id: this.purchaseItem.id,
					date: this.dialogData.date,
					providerId: this.dialogData.providerId,
					ownerId: null,
					entryNo: this.dialogData.entryNo || 0,
					weight: 0,
					density: this.dialogData.density,
					isSeed: !isBlackPepper ? this.dialogData.isSeed : false,
					items:
						!this.dialogData.isSeed
							? this.dialogData.entires.map(c => ({
								itemId: c.id, weight: 0, percent: c.percent
							}))
							: [{ itemId: this.seedsId, weight: 0, percent: 100 }],
					pepperColumns: {
						hojos: this.dialogData.hojos || 0,
						colpila: this.dialogData.colpila || 0,
						grande: this.dialogData.grande || 0,
						maduro: this.dialogData.maduro || 0,
						mohoso: this.dialogData.mohoso || 0,
						quebrado: this.dialogData.quebrado || 0,
						pequeño: this.dialogData.pequeño || 0,
						mediano: this.dialogData.mediano || 0,
						con_Collila: this.dialogData.con_Collila || 0,
						verde: this.dialogData.verde || 0,
					}
				}).then(() => {
					this.$eventBus.$emit(
						'show-snackbar',
						!this.purchaseItem.id
							? this.$T('messages.purchase-added')
							: this.$T('messages.purchase-edited'),
						'info'
					);
					this.dialog = false;
					this.filter();
				}).finally(() => {
					this.submitLoading = false;
				})
			}
		},

		submitAcceptance() {
			if (this.$refs.statusForm.validate()) {
				this.submitLoading = true;
				this.$store.dispatch('purchases/updateState', {
					id: this.purchaseItem.id,
					administrationPrice: this.itemState.price,
					administrationAcceptance: this.itemState.administrationAcceptance,
					farmerAcceptance: this.itemState.farmerAcceptance,
				}).then(() => {
					this.statusDialog = false;
					this.$eventBus.$emit('show-snackbar', this.$T('messages.purchase-state-updated'), 'info');
					this.filter();
				}).finally(() => {
					this.submitLoading = false;
				})
			}
		},

		// helpers
		setItemsStates(item) {
			this.itemState.status = item.status;
			this.itemState.administrationAcceptance = item.administrationAcceptance;
			this.itemState.farmerAcceptance = item.farmerAcceptance;
			this.itemState.price = item.administrationPrice;
			this.itemState.priceFormat = this.$options.filters.numberFormat(item.administrationPrice)
			// this.itemState.price = fixNumber(Math.random() * 150000);
		},

		getStatusColor(val, isText = true) {
			return val !== null ? (val ? 'success' : 'alert-color') + (isText ? '--text' : '') : null;
		},
		getStatusText(val) {
			return val !== null ? (val ? this.$T('accepted') : this.$T('rejected')) : this.$T('waiting');
		},

		getWeightedAveragesByProvider (id) {
			if (this.dialogData.isSeed === false) {
				this.loadingWeightedAverages = true
				return this.$store.dispatch('purchases/getWeightedAveragesByProvider', { providerId: id }).then((data) => {
					this.dialogData.entires.forEach((entry, index) => {
						const item = data.find(c => c.itemId === entry.id);
						if (item) {
							this.dialogData.entires[index].weightedAveragePercentage = item.weightedAveragePercentage;
						} else {
							this.dialogData.entires[index].weightedAveragePercentage = 0
						}
					})
				}).then(() => {
					this.loadingWeightedAverages = false
				}).catch(() => {
					this.loadingWeightedAverages = false
				})
			}
		},
		
		fixNumber
	},

	created() {
		this.filter();
	},

	/* beforeRouteEnter(to, from, next) {
		next(vm => {
			if (vm.permissions.purchases.isNone) {
				next({ name: 'home', replace: true });
			}
			return true;
		});
	} */
}
</script>

<style lang="scss">
.custom-foot-row {
	border-top: 1px solid #e0e0e0;
}
#purchases {
	.bee-handy-smart-table__input-cell {
		padding: 0 8px;
		
		&:last-child { padding: 0; }
	}
}
</style>